module.exports = __webpack_public_path__ + "static/media/Wecan-logo.11557a6b.jpeg";